export const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1200px',
  
  media: {
    mobile: '@media (max-width: 768px)',
    tablet: '@media (max-width: 1024px)',
    desktop: '@media (min-width: 769px)',
    large: '@media (min-width: 1200px)',
  },
  
  values: {
    mobile: 768,
    tablet: 1024,
    desktop: 1200,
  },
} as const;

export type Breakpoints = typeof breakpoints;